"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var times_1 = require("../../../common/constants/times");
var Task_1 = require("../../../classes/Task");
var TaskController = /** @class */ (function () {
    function TaskController($state, CrmTasksModel, FlashService, $rootScope, AdminTasksService) {
        var _this = this;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.AdminTasksService = AdminTasksService;
        this.CrmTasksModel = CrmTasksModel;
        this.FlashService = FlashService;
        this.hours = times_1.Hours;
        this.minutes = (0, times_1.Minutes)();
        this.assign_user = null;
        this.today = new Date();
        this.datepicker = {
            open: function ($event) {
                _this.datepicker.status.opened = true;
            },
            dateOptions: {
                formatYear: "yy",
                startingDay: 7,
                showWeeks: false,
            },
            format: "dd-MMMM-yyyy",
            status: {
                opened: false,
            },
        };
        var due_on_date = (0, time_1.parseDate)(this.task.$due_on);
        this.due_date = due_on_date;
        this.due_on_hours = due_on_date.getHours().toString();
        this.due_on_minutes = due_on_date.getMinutes();
        this.updateDueDate = this.updateDueDate.bind(this);
    }
    TaskController.prototype.goToUser = function (user) {
        if (user.usertype_id === 1) {
            this.$state.go("drivecoach.admin.students.view", { userId: user.id }, { reload: true });
            this.$rootScope.$broadcast("CLOSE_TASK_MODAL");
        }
        if (user.usertype_id === 3) {
            // instructor
            this.$state.go("drivecoach.admin.instructors.view", {
                instructorId: user.id,
            });
            this.$rootScope.$broadcast("CLOSE_TASK_MODAL");
        }
        if (user.usertype_id === 4 || user.usertype_id === 8) {
            // owner
            this.$state.go("drivecoach.admin.staff.view", { staffId: user.id });
            this.$rootScope.$broadcast("CLOSE_TASK_MODAL");
        }
        if (user.usertype_id === 5 || user.usertype_id === 9) {
            // admins & staff
            this.$state.go("drivecoach.admin.staff.view", { staffId: user.id });
            this.$rootScope.$broadcast("CLOSE_TASK_MODAL");
        }
    };
    TaskController.prototype.addUser = function () {
        this.task.$users.push(this.assign_user);
    };
    TaskController.prototype.removeUser = function (index) {
        this.task.$users.splice(index, 1);
    };
    TaskController.prototype.updateDueDate = function (newDate) {
        this.due_date = newDate.selected[0];
    };
    TaskController.prototype.submit = function () {
        var _this = this;
        this.submitted = true;
        var data = (0, Task_1.taskRequestTransformer)(this.task);
        data.due_date = (0, time_1.formatDateTime)(this.due_date, "MM/DD/YYYY");
        data.due_time = (0, time_1.formatDateTime)(new Date(0, 0, 0, parseInt(this.due_on_hours, 10), this.due_on_minutes), "HH:mm");
        this.CrmTasksModel.update(data)
            .then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.AdminTasksService.tasks.find(function (t) { return t.id === response.task.id; })) {
                // update tasks
                var task = new Task_1.Task(response.task);
                _this.AdminTasksService.updateTask(task);
            }
            _this.$rootScope.$broadcast("TASKS_UPDATED");
        })
            .catch(function (response) {
            _this.submitted = false;
        });
    };
    return TaskController;
}());
TaskController.$inject = [
    "$state",
    "CrmTasksModel",
    "FlashService",
    "$rootScope",
    "AdminTasksService",
];
exports.default = TaskController;
